import { createI18n } from 'vue-i18n';
import messages from './../../langs/messages.json';

export default createI18n({
  legacy: false,
  locale: document.getElementsByTagName('html')[0].getAttribute('lang'),
  fallbackLocale: 'fr',
  messages,
});
